import { render, staticRenderFns } from "./Tfp.vue?vue&type=template&id=2ed2559c&scoped=true&"
import script from "./Tfp.vue?vue&type=script&lang=js&"
export * from "./Tfp.vue?vue&type=script&lang=js&"
import style0 from "./Tfp.vue?vue&type=style&index=0&id=2ed2559c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2559c",
  null
  
)

export default component.exports